import React from 'react'
import { withRouter } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import TextField from '@material-ui/core/TextField'
import GradientButton from 'components/common/GradientButton'
import useForm from 'hooks/useForm'
import useGlobal from 'hooks/useGlobal'
import api from 'utils/api'
import { useSnackbar } from 'notistack'

const useStyles = makeStyles(theme => ({
	button: {
		marginTop: theme.spacing(1),
	},
}))

function InstallForm({ history }) {
	const classes = useStyles()
	const { enqueueSnackbar } = useSnackbar()
	const [, configActions] = useGlobal(state => null, actions => actions.config)

	const { values, errors, isSubmitting, setIsSubmitting, handleSubmit, handleChange } = useForm(
		{
			username: '',
			password: '',
			wc_host: 'localhost',
			wc_user: '',
			wc_password: '',
			wc_db: '',
		},
		onSubmit,
		validate
	)

	async function onSubmit() {
		try {
			await api.post('/api/install.php', values)
			configActions.getConfig()
		} catch (e) {
			setIsSubmitting(false) // 성공한 경우 경로가 변경되므로 reset이나 summit 상태 변경이 필요없다
			enqueueSnackbar('DB에 접속할 수 없습니다.', { variant: 'error' })
		}
	}

	function validate(values) {
		let errors = {}
		if (!values.username.trim()) {
			errors.username = '아이디를 입력하세요.'
		} else if (!/^[A-Za-z]+[A-Za-z0-9]{3,20}$/g.test(values.username)) {
			errors.username = '첫 글자 영문, 영문 + 숫자만 가능, 4~20자'
		}
		if (!values.password.trim()) {
			errors.password = '비밀번호를 입력하세요.'
		} else if (!/^[A-Za-z0-9]{4,20}$/g.test(values.password)) {
			errors.password = '영문 + 숫자만 가능, 4~20자'
		}
		if (!values.wc_host.trim()) {
			errors.wc_host = 'MySQL Host를 입력하세요.'
		}
		if (!values.wc_user.trim()) {
			errors.wc_user = 'MySQL User를 입력하세요.'
		}
		if (!values.wc_password.trim()) {
			errors.wc_password = 'MySQL Password를 입력하세요.'
		}
		if (!values.wc_db.trim()) {
			errors.wc_db = 'MySQL DB를 입력하세요.'
		}
		return errors
	}

	return (
		<form onSubmit={handleSubmit} noValidate>
			<TextField
				type="text"
				name="username"
				label="아이디"
				placeholder="관리자 아이디"
				margin="normal"
				fullWidth
				autoComplete="username"
				autoFocus
				helperText={errors.username || '첫 글자 영문, 영문 + 숫자만 가능, 4~20자'}
				value={values.username}
				error={!!errors.username}
				onChange={handleChange}
			/>
			<TextField
				type="password"
				name="password"
				label="비밀번호"
				placeholder="관리자 비밀번호"
				margin="normal"
				fullWidth
				autoComplete="current-password"
				helperText={errors.password || '영문 + 숫자만 가능, 4~20자'}
				value={values.password}
				error={!!errors.password}
				onChange={handleChange}
			/>
			<TextField
				type="text"
				name="wc_host"
				label="MySQL Host"
				placeholder="MySQL 호스트 주소"
				margin="normal"
				fullWidth
				helperText={errors.wc_host}
				value={values.wc_host}
				error={!!errors.wc_host}
				onChange={handleChange}
			/>
			<TextField
				type="text"
				name="wc_user"
				label="MySQL User"
				placeholder="MySQL 계정 아이디"
				margin="normal"
				fullWidth
				helperText={errors.wc_user}
				value={values.wc_user}
				error={!!errors.wc_user}
				onChange={handleChange}
			/>
			<TextField
				type="password"
				name="wc_password"
				label="MySQL Password"
				placeholder="MySQL 비밀번호"
				margin="normal"
				fullWidth
				helperText={errors.wc_password}
				value={values.wc_password}
				error={!!errors.wc_password}
				onChange={handleChange}
			/>
			<TextField
				type="text"
				name="wc_db"
				label="MySQL DB"
				placeholder="MySQL DB명"
				margin="normal"
				fullWidth
				helperText={errors.wc_db}
				value={values.wc_db}
				error={!!errors.wc_db}
				onChange={handleChange}
			/>
			<GradientButton
				type="submit"
				variant="contained"
				color="primary"
				fullWidth
				disabled={isSubmitting}
				className={classes.button}
			>
				설치
			</GradientButton>
		</form>
	)
}

export default withRouter(InstallForm)
